import PremiumFeatureGate from "@components/common/premium/PremiumFeatureGate";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCompanion } from "@hooks/use-companion";

export const CompanionNavButton = ({
  icon,
  title,
  onClick,
  isTabActive,
}) => {
  return (
    <FontAwesomeIcon
      icon={icon}
      title={title}
      size="lg"
      className={`cursor-pointer p-2 rounded-full size-4 text-white ${
        isTabActive ? "bg-indigo-800" : "hover:bg-indigo-800/50"
      }`}
      onClick={onClick}
      data-testid={`companion-nav-${title
        .toLowerCase()
        .replace(" ", "-")}`}
    />
  );
};

export const NewSessionButton = () => {
  const { creatingSession, createNewSession } = useCompanion();

  return (
    <PremiumFeatureGate
      featureName="Companion"
      className="flex grow mt-2"
      iconPosition="top-right"
    >
      <button
        className={`w-full mt-3 border-2 border-dashed border-indigo-300 rounded-full text-white py-2 text-sm transition-colors ${
          creatingSession
            ? "opacity-50 cursor-not-allowed"
            : "hover:bg-indigo-500/50"
        }`}
        onClick={createNewSession}
        disabled={creatingSession}
        data-testid="companion-new-chat-button"
      >
        <FontAwesomeIcon icon={faPlus} />{" "}
        <span className="ml-2">New Chat</span>
      </button>
    </PremiumFeatureGate>
  );
};
